import { getAuth, signOut } from "firebase/auth";

import { store } from "../store/store";
import { clearUser } from "../store/userSlice";
import { clearCachedAuthToken } from "../setupAxios";

/** Clears Firebase auth, Redux user, and cached API token (e.g. before password reset). */
export async function clearAuthSession(): Promise<void> {
  clearCachedAuthToken();
  store.dispatch(clearUser());
  localStorage.removeItem("lastActive");

  try {
    await signOut(getAuth());
  } catch {
    // No active Firebase session
  }
}
